import {Component, Prop} from 'vue-property-decorator';
import * as tsx from 'vue-tsx-support';
import yuan from '@/utils/yuan';
import {minutestoDate} from '@/utils/timestampToDate';
import Log from '@/components/Log';

import './style.less';

interface IOrderDetails {
  data?: object;
  number?: number
}

@Component
export default class OrderDetails extends tsx.Component<IOrderDetails> {
  
  @Prop() data?: object
  @Prop() number?: number
  
  state = {
    time: 60 * 60 - 1
  }
  
  mounted () {
    const time = setInterval(() => {
      if (this.state.time === 0) {
        clearInterval(time)
        return false
      }
      this.state.time = this.state.time - 1
    }, 1000)
  }
  
  render() {
    const {data,number} = this.$props;
    return (
      <div class='orderDetails-container'>
        <div class='container-padding item-container'>
          <span class='package-title'>{data.title}</span>
          <span class='package-time'>剩余支付时间 {minutestoDate(this.state.time)}</span>
        </div>
        <div class='container-padding item-container'>
          <span class='subtitle'>{data.title}</span>
          <span class='amount-number'>¥ {yuan(data.price)}</span>
        </div>
        <div class='container-padding item-container'>
          <span class='subtitle'>支付类型</span>
          <span>{data.priceType === 1 ? '新购' : '续费' }</span>
        </div>
        <Log number='N1010'>
          <div class='container-padding item-container'>
            <span class='subtitle'>代金劵/红包</span>
            <div class="cardVoucher-right">
              <span class='cardVoucher-number'>{number}个可用</span>
              <span class='cardVoucher-img'>  </span>
            </div>
  
          </div>
        </Log>
        <div class='container-padding item-container' style='justify-content: flex-end;'>
          <div class='subtitle' style='marginRight: 1.14286vw'>小计</div>
          <div class='amount-number'>¥ {yuan(data.price)}</div>
        </div>
      </div>
    )
  }
  
}